<template>
  <!--关于我们-->
  <div class="aboutUs">
    <div class="banner">
      <div class="banner_text">
        <div class="banner_text_title">关于我们</div>
        <div class="banner_text_pgh"><span>A</span>bout us</div>
      </div>
      <div class="banner_img_pc">
        <img src="@/asstes/aboutUs/banner.png" />
      </div>
      <div class="banner_img_app">
        <img src="@/asstes/aboutUs/banner_app.png" />
      </div>
    </div>
    <!--公司简介-->
    <div class="company_pc">
      <div class="company_info">
        <div class="company_info_title">无锡挚达数智科技有限公司</div>
        <div class="company_info_pgh">
          无锡挚达数智科技公司成立于2017年，是上海挚达科技发展有限公司的全资子公司，是江苏省高新技术企业，位于江苏省无锡经济开发区清舒道60号海归小镇2号楼202室。拥有研发办公场地1200㎡，员工近60人，其中技术研发人员近50人，本科及以上学历约占职工总数63%。
          <br />
          <br />
          秉承物联网发展战略，以新能源科技为先导，依托同济大学、江南大学等高等科研院校和公司专业研发人员，把绿色出行行业的终端+IOT+平台+算法服务的“云/管/端”集成系统开发作为战略核心。
          在发展自身产品及系统平台研发的基础上，积极从事与车联网、桩联网、综合能源互联网服务等相关的软件系统平台研发，为绿色出行运营公司、新能源汽车整车企业、国家电力/电网、储能、太阳能电力行业等提供“软硬一体化”的综合解决方案。
        </div>
      </div>
      <div class="company_img">
        <img src="@/asstes/aboutUs/zd2.png" />
        <!--                <div class="info_img_first">-->
        <!--                    <img src="@/asstes/aboutUs/zd1.png">-->
        <!--                </div>-->
        <!--                <div class="info_img_second">-->
        <!--                    <img src="@/asstes/customerCase/background.png">-->
        <!--                </div>-->
      </div>
    </div>
    <div class="company_app">
      <div class="company_img">
        <div class="info_img_first">
          <img src="@/asstes/aboutUs/zd1.png" />
        </div>
        <div class="info_img_second">
          <img src="@/asstes/customerCase/background.png" />
        </div>
      </div>
      <div class="company_info">
        <div class="company_info_title">无锡挚达数智科技有限公司</div>
        <div class="company_info_pgh">
          无锡挚达数智科技有限公司成立于2017年，是上海挚达发展科技有限公司的全资子公司，是江苏省高新技术企业，位于江苏省无锡经济开发区清舒道60号海归小镇2号楼202室。拥有研发办公场地1200㎡，员工近60人，其中技术研发人员近50人，本科及以上学历约占职工总数63%。
          <br />
          <br />
          秉承物联网发展战略，以新能源科技为先导，依托同济大学、江南大学等高等科研院校和公司专业研发人员，把绿色出行行业的终端+IOT+平台+算法服务的“云/管/端”集成系统开发作为战略核心。
          在发展自身产品及系统平台研发的基础上，积极从事与车联网、桩联网、综合能源互联网服务等相关的软件系统平台研发，为绿色出行运营公司、新能源汽车整车企业、国家电力/电网、储能、太阳能电力行业等提供“软硬一体化”的综合解决方案。
        </div>
      </div>
    </div>
    <!--发展历程-->
    <div class="develop_pc">
      <div class="develop_title">发展历程</div>
      <div class="develop_box">
        <div class="develop_info">
          <div
            class="develop_position"
            v-for="(item, index) in developList"
            :key="index"
          >
            <img :src="item.img" />
          </div>
        </div>
        <div class="develop_info">
          <div class="develop_shape">
            <div class="develop_shape_circular"></div>
            <div class="develop_shape_line"></div>
            <div class="develop_shape_circular"></div>
            <div class="develop_shape_line"></div>
            <div class="develop_shape_circular"></div>
            <div class="develop_shape_line"></div>
            <div class="develop_shape_circular"></div>
            <div class="develop_shape_line"></div>
            <div class="develop_shape_circular"></div>
          </div>
        </div>
        <div class="develop_info">
          <div
            class="develop_year"
            v-for="(item, index) in developList"
            :key="index"
          >
            <div class="info_year">{{ item.year }}</div>
          </div>
        </div>
        <div class="develop_info">
          <div
            class="develop_text"
            v-for="(item, index) in developList"
            :key="index"
          >
            <div class="info_text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="develop_app">
      <div class="develop_title">发展历程</div>
      <div class="develop_box">
        <div class="boxList">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) in developList"
                :key="index"
              >
                <div>
                  <img :src="item.img" />
                </div>
                <div class="boxList_shape">
                  <div class="shape_circle"></div>
                  <div class="shape_line"></div>
                </div>
                <div class="boxList_year">{{ item.year }}</div>
                <div class="boxList_text">{{ item.text }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="worldMap">
          <img src="@/asstes/aboutUs/map.png" />
        </div>
      </div>
    </div>
    <!--行业认证-->
    <div class="industry">
      <div class="industry_title">行业认证</div>
      <div class="industry_subtitle">
        已获得60个专利发明的著作权和4项
        <br />
        <br />
        通过ISO90001 、CMMI3高新技术企业认证，是江苏省民营人才科技企业、江苏<br />省双创、太湖创业领军、江南计划物工程学院联网教学实习基地
      </div>
      <Partner style="width: 100%" />
    </div>
    <!--我们的优势-->
    <div class="advantage">
      <div class="advantage_title">我们的优势</div>
      <div class="advantage_info">
        <div class="info_img">
          <div class="info_img_first">软件<br />集成</div>
          <div class="info_img_second">行业<br />沉淀</div>
          <img src="@/asstes/aboutUs/first.png" />
        </div>
        <div class="advantage_box">
          <div class="box_title">软件+硬件+互联网集成开发能力</div>
          <div class="box_pgh">
            随着互联网下半场序幕的拉开和物联网技术的快速崛起，紧盯新能源行业的发展契机，打造了一支集软件+硬件+互联网开发能力于一体的研发和交付团队。
          </div>
          <div class="box_title">能源+汽车+信息跨界融合的行业规划咨询</div>
          <div class="box_pgh">
            聚焦新能源汽车的充电、服务和出行等领域，打磨了一支新能源+汽车+信息产业跨界专家团队，为全国大型能源企业和新能源汽车主机厂担任咨询服务。
          </div>
        </div>
      </div>
    </div>
    <!--联系方式-->
    <div class="contact">
      <div class="contact_title">联系方式</div>
      <div class="contact_pgh">
        用心服务，随时响应。如果您想进一步了解桩到家品牌以及产品，或有其他任何<br />疑问，请随时与我们取得联系。
      </div>
      <div class="contact_info">
        <div class="info_map">
          <!--                    <el-amap vid="amapPro"></el-amap>-->
          <!--
                    <el-amap-search-box class="search-box" :search-option="searchOption"
                                        :on-search-result="onSearchResult" style="width: 100%"></el-amap-search-box>
                    -->
          <el-amap
            vid="amapDemo"
            :center="center"
            :zoom="zoom"
            class="amap-demo"
            :events="events"
          >
            <el-amap-marker
              :position="marker.position"
              :events="marker.events"
              :visible="marker.visible"
              :draggable="marker.draggable"
            ></el-amap-marker>
          </el-amap>
          <!--                    <div class="toolbar">position: [{{ lng }}, {{ lat }}] address: {{ address }}</div>-->
        </div>
        <div class="info_text">
          <div class="info_text_title">您可以通过以下方式联系我们</div>
          <div class="info_text_phone">
            24小时服务热线：<span>0510-81819998</span>
          </div>
          <div class="info_text_address">
            联系地址：无锡经济开发区清舒道60号海归小镇2号楼202室
          </div>
          <!-- <div class="info_text_official">
            关注公众号：
            <img src="@/asstes/aboutUs/second.png" />
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Partner from "../index/partner";
import Swiper from "swiper";
import AMap from "vue-amap";

var map, marker;
export default {
  components: {
    Partner,
  },
  data() {
    return {
      developList: [
        {
          img: require("@/asstes/aboutUs/position.png"),
          circular: require("@/asstes/aboutUs/circular.png"),
          line: require("@/asstes/aboutUs/line.png"),
          year: "2017",
          text: "无锡挚达成立",
          value: true,
        },
        {
          img: require("@/asstes/aboutUs/position.png"),
          circular: require("@/asstes/aboutUs/circular.png"),
          line: require("@/asstes/aboutUs/line.png"),
          year: "2018",
          text: "打造“绿色共享开放式平台”",
          value: true,
        },
        {
          img: require("@/asstes/aboutUs/position.png"),
          circular: require("@/asstes/aboutUs/circular.png"),
          line: require("@/asstes/aboutUs/line.png"),
          year: "2019",
          text: "江苏省民营科技企业、国家高新技术企业、创建挚达科技智能网联（中国）创新中心",
          value: true,
        },
        {
          img: require("@/asstes/aboutUs/position.png"),
          circular: require("@/asstes/aboutUs/circular.png"),
          line: require("@/asstes/aboutUs/line.png"),
          year: "2020",
          text: "无锡市太湖创业领军人才企业、无锡经济开发区新兴产业创业领军人才企业",
          value: true,
        },
        {
          img: require("@/asstes/aboutUs/position.png"),
          circular: require("@/asstes/aboutUs/circular.png"),
          line: require("@/asstes/aboutUs/line.png"),
          year: "2021",
          text: "无锡挚达数智科技荣获“金码奖”",
          value: false,
        },
      ],
      zoom: 20,
      center: [120.318525, 31.483316],
      searchOption: {
        city: "无锡",
        citylimit: true,
      },
      marker: {
        position: [120.318525, 31.483316],
      },
      mapInfo: {
        address: "",
        lng: "",
        lat: "",
      },
      address: "",
      events: {
        click(e) {
          let { lng, lat } = e.lnglat;
          self.lng = lng;
          self.lat = lat;
          self.mapInfo.lat = lat;
          self.mapInfo.lng = lng;
          self.marker.position = [lng, lat];
          // 这里通过高德 SDK 完成。
          var geocoder = new AMap.Geocoder({
            radius: 1000,
            extensions: "all",
          });
          geocoder.getAddress([lng, lat], function (status, result) {
            if (status === "complete" && result.info === "OK") {
              if (result && result.regeocode) {
                self.address = result.regeocode.formattedAddress;
                self.mapInfo.address = result.regeocode.formattedAddress;
                self.$nextTick();
              }
            }
          });
          self.$emit("listenToMap", self.mapInfo);
        },
      },
      lng: 0,
      lat: 0,
    };
  },
  mounted() {
    new Swiper(".swiper-container", {
      loop: false,
      //设置平滑
      loopedSlides: 6,
      // 设置能够同时显示的数量（可设置 auto）
      slidesPerView: "auto",
      // 切换速度
      speed: 1000,

      // 如果需要分页器
      pagination: "", //.swiper-pagination
      // 如果需要前进后退按钮
      nextButton: "", //.swiper-button-next
      prevButton: "", //.swiper-button- prev
      // 如果需要滚动条
      scrollbar: "", //.swiper-scrollbar
      centeredSlides: true, //  居中
    });
  },
  methods: {
    // onSearchResult(pois) {
    //     console.log(pois,'pois')
    //     var lng = pois[0].lng
    //     var lat = pois[0].lat
    //     this.lng=pois[0].lng
    //     this.lat=pois[0].lat
    //     this.center = [lng, lat];
    //     this.marker.position = [lng, lat]
    //     this.address=pois[0].name
    //     this.mapInfo.lat=lat
    //     this.mapInfo.lng=lng
    //     this.mapInfo.address=pois[0].name
    //     this.$emit("listenToMap",this.mapInfo);
    // }
  },
};
</script>

<style lang="less" scoped>
@media only screen and (max-width: 750px) {
  .aboutUs {
    .banner {
      margin-top: -220px;
      position: relative;

      .banner_text {
        position: absolute;
        top: 756px;
        left: 162px;
        color: #353856;
        .banner_text_title {
          font-size: 84px;
          font-weight: 600;
          line-height: 120px;
          padding-bottom: 48px;
          box-sizing: border-box;
        }
        .banner_text_pgh {
          font-size: 57.6px;
          font-weight: 600;
          line-height: 46px;

          span {
            font-size: 86.4px;
          }
        }
      }

      .banner_img_pc {
        display: none;
      }
      .banner_img_app {
        img {
          width: 100%;
        }
      }
    }

    .company_pc {
      display: none;
    }
    .company_app {
      width: 100%;
      padding: 216px 144px 64px 144px;
      box-sizing: border-box;
      text-align: center;
      .company_img {
        position: relative;
        .info_img_first {
          position: absolute;
          top: 76px;
          left: 30px;
          overflow: hidden;
          img {
            width: 85%;
          }
        }
        .info_img_second {
          img {
            width: 100%;
          }
        }
      }
      .company_info {
        padding-top: 180px;
        box-sizing: border-box;

        .company_info_title {
          font-weight: 600;
          color: #373a5a;
          font-size: 79.2px;
          padding-bottom: 86.4px;
          box-sizing: border-box;
        }
        .company_info_pgh {
          text-align: left;
          font-size: 50.4px;
          line-height: 90px;
        }
      }
    }

    .develop_pc {
      display: none;
    }
    .develop_app {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      text-align: center;

      .develop_title {
        font-weight: 600;
        color: #373a5a;
        font-size: 79.2px;
        padding-top: 160px;
        padding-bottom: 240px;
        box-sizing: border-box;
      }

      .develop_box {
        width: 100%;
        padding: 0px 0 240px 0;
        box-sizing: border-box;
        position: relative;

        .boxList {
          text-align: left;
          z-index: 90;

          .swiper-container {
            overflow: hidden;
            padding: 0 160px;
            box-sizing: border-box;

            .swiper-slide {
              display: flex;
              flex-wrap: wrap;
              justify-content: flex-start;
              width: 80% !important;

              img {
                padding-bottom: 147px;
                box-sizing: border-box;
              }

              .boxList_shape {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                padding-bottom: 108px;
                padding-left: 60px;
                box-sizing: border-box;

                .shape_circle {
                  width: 40px;
                  height: 40px;
                  border: 4px solid #000;
                  border-radius: 40px;
                }
                .shape_line {
                  width: calc(100% - 180px);
                  height: 3px;
                  background-color: #000;
                  margin: 0 60px 0 120px;
                }
              }

              .boxList_year {
                width: 100%;
                font-weight: 600;
                color: #0bbab4;
                padding-bottom: 90px;
                box-sizing: border-box;
                font-size: 79.2px;
              }
              .boxList_text {
                font-size: 43.2px;
                font-weight: 400;
                color: #000000;
                max-width: 640px;
                box-sizing: border-box;
              }
            }

            .swiper-slide:last-child {
              .boxList_shape {
                .shape_line {
                  background-color: rgba(0, 0, 0, 0);
                }
              }
            }
          }
        }

        .worldMap {
          position: absolute;
          top: -80px;
          width: 100%;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: -1;
          img {
            width: 140%;
          }
        }
      }
    }

    .industry {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 120px 144px 0px 144px;
      box-sizing: border-box;

      .industry_title {
        font-weight: 600;
        color: #373a5a;
        font-size: 79.2px;
        padding-bottom: 86.4px;
        box-sizing: border-box;
      }
      .industry_subtitle {
        font-size: 43.2px;
        color: #373a5a;
        font-weight: 400;
        padding-bottom: 72px;
        box-sizing: border-box;
      }
    }

    .advantage {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 120px 144px 0px 144px;
      box-sizing: border-box;

      .advantage_title {
        font-weight: 600;
        color: #373a5a;
        font-size: 79.2px;
        padding-bottom: 86.4px;
        box-sizing: border-box;
      }

      .advantage_info {
        .info_img {
          padding: 216px 0;
          box-sizing: border-box;
          position: relative;
          font-size: 57.6px;
          color: #0bbab4;
          font-weight: 600;
          .info_img_first {
            position: absolute;
            top: 426px;
            left: 226px;
          }
          .info_img_second {
            position: absolute;
            top: 426px;
            left: 654px;
          }
          img {
            width: 100%;
          }
        }

        .advantage_box {
          .box_title {
            font-weight: 600;
            font-size: 68px;
            color: #373a5a;
            padding-bottom: 90px;
            box-sizing: border-box;
          }
          .box_pgh {
            color: #000000;
            font-weight: 400;
            font-size: 50.4px;
            padding-bottom: 126px;
            box-sizing: border-box;
            text-align: left;
          }
        }
      }
    }

    .contact {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 120px 144px 180px 144px;
      box-sizing: border-box;

      .contact_title {
        font-weight: 600;
        color: #373a5a;
        font-size: 79.2px;
        padding-bottom: 86.4px;
        box-sizing: border-box;
      }

      .contact_pgh {
        font-size: 43.2px;
        color: #373a5a;
        font-weight: 400;
        padding-bottom: 72px;
        box-sizing: border-box;
      }

      .contact_info {
        background: #ffffff;
        box-shadow: -3px 7px 15px 0px rgba(220, 217, 217, 0.5);
        border-radius: 40px;

        .info_map {
          max-width: 1200px;
          height: 1200px;
          border-top-left-radius: 48px;
          border-top-right-radius: 48px;
          overflow: hidden;
        }

        .info_text {
          padding: 90px;
          box-sizing: border-box;
          text-align: right;
          color: #353856;

          .info_text_title {
            font-size: 57.6px;
            font-weight: 600;
            padding-bottom: 216px;
            box-sizing: border-box;
          }
          .info_text_phone {
            font-size: 43.2px;
            padding-bottom: 57.6px;
            box-sizing: border-box;
            font-weight: 400;
            span {
              color: #00d1b0;
            }
          }
          .info_text_address {
            width: 100%;
            font-size: 43.2px;
            font-weight: 400;
            color: #353856;
            padding-bottom: 90px;
            box-sizing: border-box;
          }
          .info_text_official {
            display: flex;
            justify-content: flex-end;
            font-size: 43.2px;
            font-weight: 400;
            color: #353856;
            img {
              width: 24%;
            }
          }
        }
      }
    }
  }
}

@media only screen and (min-width: 750px) {
  .aboutUs {
    margin-top: -48px;
    z-index: 80;

    .banner {
      position: relative;

      .banner_text {
        position: absolute;
        top: 50%;
        left: 104px;
        margin-top: -50px;
        color: #353856;

        .banner_text_title {
          font-size: 36px;
          font-weight: 600;
          line-height: 50px;
          padding-bottom: 16px;
          box-sizing: border-box;
        }

        .banner_text_pgh {
          font-size: 24px;
          font-weight: 600;
          line-height: 46px;
        }
        span:first-child {
          font-size: 32px;
        }
      }

      .banner_img_pc {
        img {
          width: 100%;
        }
      }
      .banner_img_app {
        display: none;
      }
    }

    .company_pc {
      padding: 80px 120px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .company_info {
        max-width: 280px;
        color: #353856;

        .company_info_title {
          font-size: 24px;
          font-weight: 600;
          line-height: 32px;
          padding-bottom: 24px;
          box-sizing: border-box;
          width: 400px;
        }
        .company_info_pgh {
          width: 440px;
          font-size: 15px;
          font-weight: 400;
          line-height: 28px;
        }
      }
      .company_img {
        padding-left: 80px;
        box-sizing: border-box;

        img {
          width: 100%;
        }
        /*.info_img_first{*/
        /*    z-index: 120;*/
        /*    width: 380px;*/
        /*    height: 300px;*/
        /*    overflow: hidden;*/
        /*    border-radius: 16px;*/
        /*    img{*/
        /*        position: absolute;*/
        /*        top: -10px;*/
        /*        left: -180px;*/
        /*    }*/
        /*}*/

        /*.info_img_second{*/
        /*    z-index: 110;*/
        /*}*/
      }
    }
    .company_app {
      display: none;
    }

    .develop_pc {
      text-align: center;

      .develop_title {
        width: 100%;
        font-size: 24px;
        font-weight: 600;
        color: #353856;
        line-height: 32px;
        padding-bottom: 24px;
        box-sizing: border-box;
      }

      .develop_box {
        background-image: url("../../asstes/aboutUs/map.png");
        background-repeat: no-repeat;
        background-position: center;

        .develop_info {
          padding: 0 160px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;

          .develop_position {
            padding: 160px 0 16px 0;
            box-sizing: border-box;

            img {
              width: 100%;
              padding: 0 4px;
              box-sizing: border-box;
            }
          }

          .develop_shape {
            width: 100%;
            padding-bottom: 16px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;

            img:first-child {
              /*padding: 0 16px;*/
              /*box-sizing: border-box;*/
            }

            .develop_shape_circular {
              width: 12px;
              height: 12px;
              border-radius: 16px;
              border: 3px solid #000;
              margin: 0 18px;
            }
            .develop_shape_line {
              width: 200px;
              height: 2px;
              background-color: #000;
            }
          }
          .develop_year {
            padding-bottom: 16px;
            box-sizing: border-box;

            .info_year {
              font-size: 24px;
              font-weight: 600;
              color: #0bbab4;
              line-height: 32px;
            }
          }
          .develop_text {
            padding-bottom: 160px;
            box-sizing: border-box;
            text-align: left;

            .info_text {
              max-width: 140px;
              font-size: 14px;
              font-weight: 400;
              color: #000000;
              line-height: 20px;
            }
          }
        }
      }
    }
    .develop_app {
      display: none;
    }

    .industry {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      text-align: center;
      color: #353856;
      width: 100%;
      padding: 64px 120px;
      box-sizing: border-box;

      .industry_title {
        width: 100%;
        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
        padding-bottom: 16px;
        box-sizing: border-box;
      }
      .industry_subtitle {
        width: 100%;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        padding-bottom: 48px;
        box-sizing: border-box;
      }
    }

    .advantage {
      text-align: center;
      color: #353856;
      padding-top: 60px;
      box-sizing: border-box;

      .advantage_title {
        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
      }

      .advantage_info {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: left;
        padding: 64px 120px;

        .info_img {
          width: calc(60% + 16px);
          padding-right: 48px;
          box-sizing: border-box;
          position: relative;
          font-size: 24px;
          font-weight: 600;
          color: #0bbab4;
          line-height: 34px;
          text-align: center;

          .info_img_first {
            position: absolute;
            top: 76px;
            left: 178px;
          }

          .info_img_second {
            position: absolute;
            top: 76px;
            left: 344px;
          }
          img {
            width: 68%;
          }
        }

        .box_title {
          font-size: 24px;
          font-weight: 600;
          color: #373a5a;
          line-height: 32px;
          padding-bottom: 16px;
          box-sizing: border-box;
        }

        .box_pgh {
          max-width: 440px;
          font-size: 14px;
          font-weight: 400;
          color: #000000;
          line-height: 24px;
          padding-bottom: 24px;
          box-sizing: border-box;
        }
      }
    }

    .contact {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      text-align: center;
      color: #353856;
      padding: 0 120px 100px 120px;

      .contact_title {
        width: 100%;
        font-size: 24px;
        font-weight: 600;
        line-height: 34px;
        padding-bottom: 16px;
        box-sizing: border-box;
      }
      .contact_pgh {
        width: 100%;
        font-size: 14px;
        font-weight: 400;
        line-height: 17px;
        padding-bottom: 50px;
        box-sizing: border-box;
      }

      .contact_info {
        width: 1040px;
        background: #ffffff;
        box-shadow: 0px 9px 23px 9px rgba(222, 222, 222, 0.5);
        border-radius: 16px;
        text-align: right;
        font-size: 12px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        .info_map {
          width: 60%;
          height: 360px;
          background-color: #000;
          border-bottom-left-radius: 16px;
          border-top-left-radius: 16px;
          overflow: hidden;
        }
        .info_text {
          padding-right: 24px;
          padding-bottom: 24px;
          box-sizing: border-box;
          color: #000;
          .info_text_title {
            font-size: 14px;
            font-weight: 600;
            padding-bottom: 48px;
            box-sizing: border-box;
          }
          .info_text_phone,
          .info_text_address,
          .info_text_official {
            font-size: 12px;
            font-weight: 400;
            color: #353856;
          }
          .info_text_phone {
            span {
              color: #00d1b0;
            }
          }
          .info_text_address,
          .info_text_phone {
            padding-bottom: 16px;
            box-sizing: border-box;
          }
          .info_text_official {
            display: flex;
            justify-content: flex-end;
            img {
              width: 24%;
            }
          }
        }
      }
    }
  }
}
</style>
